import React, { useEffect, useState, useRef } from 'react';
import GuestPicker from './GuestPicker';
import { pushFieldToDataLayer } from './guestwiseTracking';

const GuestEnquiryDetails = (props) => {
    const {
        occasionBooking,
        guestInfo,
        areaInfo,
        onChange,
        createEnquiry,
        isCheckingAvailability,
        onGuestChange,
        minimumNumberOfGuests,
        guestNumberHelperText,
        enableCustomField,
        customFieldLabel,
        errorMessage
    } = props;
    const { numberOfGuests, firstName, lastName, email, phone, consent, customFieldValue, specialRequest } = guestInfo;
    const { areaMessage } = areaInfo;

    const handleNumberOfGuestsChange = (e) => {
        onGuestChange(e);
        if(e === '')
            onChange('numberOfGuests', numberOfGuests)
        else
            onChange('numberOfGuests', e)
    }

    const isButtonValid = () => {
        if (numberOfGuests && firstName && lastName && email && phone) {
            return true;
        }
        return false;
    }

    return (
        <div className="guest-enquiry-details">
            <p>For large bookings we need to check with the restaurant before we can book your table. Please fill out the form and we'll get back to you within 4 hours.</p>

            <div className='flex mt-6'>
                <div className='flex flex-col gap-4'>
                    <div className='flex gap-4'>
                        <div style={{ minWidth: "100%" }}>
                            <GuestPicker
                                occasionBooking={occasionBooking}
                                {...guestInfo}
                                idPrefix="enquiry"
                                onChange={handleNumberOfGuestsChange}
                                minimumNumberOfGuests={minimumNumberOfGuests}
                            />
                            <p>{guestNumberHelperText || "Please include any children you're bringing in your total number of guests. You can tell us if you need a highchair later in the booking process."}</p>
                        </div>
                    </div>
                    <div className='flex gap-4'>
                        <div>
                            <label className='label' htmlFor="enquiry-first-name">First name</label>
                            <input id="enquiry-first-name" name="firstname" data-guestwise="firstname"
                                className='input' value={firstName} onChange={(e) => onChange('firstName', e.target.value)}
                                autoComplete="given-name"
                                onBlur={() => pushFieldToDataLayer('enquiry_field_update', 'firstname', firstName)}></input>
                        </div>
                        <div className='grow'>
                            <label className='label' htmlFor="enquiry-last-name">Last name</label>
                            <input id="enquiry-last-name" name="lastname" data-guestwise="lastname"
                                className='input' value={lastName} onChange={(e) => onChange('lastName', e.target.value)}
                                autoComplete="family-name"
                                onBlur={() => pushFieldToDataLayer('enquiry_field_update', 'lastname', lastName)}></input>
                        </div>
                    </div>
                    <div className='flex gap-4'>
                        <div className='grow'>
                            <label className='label' htmlFor="enquiry-email">Email</label>
                            <input id="enquiry-email" name="email" data-guestwise="email"
                                value={email} type="email" className='input' onChange={(e) => onChange('email', e.target.value)}
                                autoComplete="email"
                                onBlur={() => pushFieldToDataLayer('enquiry_field_update', 'email', email)}></input>
                        </div>
                    </div>
                    <div className='flex gap-4'>
                        <div className='grow'>
                            <label className='label' htmlFor="enquiry-phone">Phone number</label>
                            <input id="enquiry-phone" name="phone" data-guestwise="phone"
                                value={phone} onChange={(e) => onChange('phone', e.target.value)}
                                autoComplete="tel"
                                onBlur={() => pushFieldToDataLayer('enquiry_field_update', 'phone', phone)}></input>
                        </div>
                    </div>
                    <div className={enableCustomField && customFieldLabel ? 'flex gap-4' : 'booking-step--hidden'} aria-hidden={enableCustomField && customFieldLabel ? undefined : true}>
                        <div className='grow'>
                            <label className='label' htmlFor="enquiry-special-requests">{customFieldLabel || 'Special requests'}</label>
                            <input
                                id="enquiry-special-requests" className='input' data-guestwise="specialRequest" value={specialRequest || ""}
                                maxLength={200}
                                onChange={(e) => onChange('specialRequest', e.target.value)}
                                onBlur={() => pushFieldToDataLayer('enquiry_field_update', 'specialRequest', specialRequest)}
                            />
                        </div>
                    </div>
                    <div className='flex gap-4'>
                        <div className="flex flex-row gap-4">
                            <input type='checkbox' name="content" id="enquiry-marketing-consent" checked={consent} value={consent} onChange={() => onChange('consent', !consent)} />
                            <label htmlFor="enquiry-marketing-consent">We’d love to keep you updated with news and offers about similar products and services. We’ll use the details you’ve provided for this purpose, unless you tell us not to.
                                Untick this box if you do not want to receive marketing communications from us.
                                For more information, see our <a className="underline" href="https://www.prezzo.co.uk/privacy-policy">Privacy Policy</a>.</label>
                        </div>
                    </div>
                    {errorMessage && (
                        <div className="p-4 bg-tomato text-off-white">
                            <div className="flex gap-2">
                                <div className="box-icon items-center flex">
                                    <img src="/icons/common/offwhite/alert-circle.svg" alt="alert" />
                                </div>
                                <div>{errorMessage}</div>
                            </div>
                        </div>
                    )}
                    <div className="mt-4">
                        <button type="button" className="button button-secondary" disabled={!isButtonValid() || isCheckingAvailability} onClick={() => createEnquiry()}>
                            <div className='flex flex-[1-1-100%] gap-2 text-center justify-center'>
                                <div>Enquire now</div>
                                {isCheckingAvailability &&
                                    <div className='box-icon flex flex-col justify-center'>
                                        <div className="loader-small"></div>
                                    </div>
                                }
                            </div>
                        </button>
                    </div>
                </div>
            </div>
            {areaMessage && <div>
                <h3>What to know before you go</h3>
                <p>{areaMessage}</p>
            </div>}
        </div>);

}

export default GuestEnquiryDetails;
